<template>
  <form
    :name="name"
    :action="success === '' ? false : success"
    method="POST"
    netlify
    netlify-honeypot="bot-field"
  >
    <input type="hidden" name="form-name" :value="name" />
    <label hidden class="hidden" v-if="honeypot">
      Don’t fill this out if you're human:
      <input name="bot-field" />
    </label>

    <slot></slot>
  </form>
</template>

<script>
export default {
  props: {
    name: {
      type: String,
      required: true
    },
    success: {
      type: String,
      default: ''
    },
    honeypot: {
      type: Boolean,
      default: true
    }
  }
};
</script>



// WEBPACK FOOTER //
// src/components/forms/NetlifyForm.vue